import { bootstrapApplication } from '@angular/platform-browser';
import { ErrorHandler } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { GlobalErrorHandlerService } from './app/core/services/global-error-handler.service';
import { httpLoggingInterceptor } from './app/core/services/http-logging.interceptor';
import { retailGroupContextInterceptor } from './app/core/services/retail-group-context.interceptor';
import { uiPreviewHttpInterceptor } from './app/core/services/ui-preview.service';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    provideIonicAngular(),
    provideHttpClient(
      withInterceptors([
        retailGroupContextInterceptor,
        uiPreviewHttpInterceptor,
        httpLoggingInterceptor,
      ])
    ),
    provideRouter(routes, withPreloading(PreloadAllModules)),
  ],
});
